import rolecatalogAPI from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

  export const getCategories = async () => {
    const { data } = await rolecatalogAPI.get(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/category`
    );
  
    return data;
  };
  
  export const createCategories = async (createInfo: any) => {
    const { data } = await rolecatalogAPI.post(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/category`,
      createInfo
    );
  
    return data;
  };
  
  export const updateCategories = async (updateInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/category/${updateInfo?.id}`,
      {
        ...updateInfo,
        id: undefined,
      }
    );
  
    return data;
  };
  
  export const deleteCategories = async (deleteInfo: any) => {
    const { data } = await rolecatalogAPI.delete(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/category/${deleteInfo?.id}`
    );
  
    return data;
  };
  
  export const reactiveCategories = async (reactiveInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/category/${reactiveInfo?.id}/reactivate`
    );
  
    return data;
  };
